var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 92,
    viewBox: "0 0 110 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.587 41.5771C109.945 40.7643 110.061 39.8828 109.971 39.0187C109.93 37.7184 109.887 36.4175 109.842 35.1166C109.844 35.1316 109.844 35.1472 109.846 35.1622C109.677 33.4645 108.709 31.8303 107.23 30.9193C107.149 30.8702 107.062 30.8281 106.982 30.7767C95.9524 23.7154 82.9224 16.1348 71.0322 10.3675C68.6022 9.19368 65.9165 9.98218 64.8921 12.0589C56.9013 28.3314 42.8564 42.2558 25.1665 52.6664C23.8522 53.4375 23.2676 54.5547 23.4388 55.68C23.4376 55.6702 23.4341 55.6609 23.4329 55.6511C23.7128 57.6423 23.9869 59.6323 24.255 61.6218C24.3662 62.4444 24.8796 63.2739 25.8111 63.9809C36.5546 72.101 47.0758 80.462 57.3624 89.0535C57.5718 89.2291 57.7982 89.3903 58.0393 89.5353C60.2069 90.8402 63.526 90.8968 65.8024 89.4816C85.4876 77.2763 101.056 60.8922 109.587 41.5783V41.5771Z",
    fill: "url(#paint0_radial_3864_6847)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.587 41.5771C109.945 40.7643 110.061 39.8828 109.971 39.0187C109.93 37.7184 109.887 36.4175 109.842 35.1166C109.844 35.1316 109.844 35.1472 109.846 35.1622C109.677 33.4645 108.709 31.8303 107.23 30.9193C107.149 30.8702 107.062 30.8281 106.982 30.7767C95.8653 23.6605 82.9213 16.136 71.0322 10.3675C68.6022 9.19368 65.9165 9.98218 64.8921 12.0589C56.9013 28.3314 42.8564 42.2558 25.1665 52.6664C23.8522 53.4375 23.2676 54.5547 23.4388 55.68C23.4376 55.6702 23.4341 55.6609 23.4329 55.6511C23.7128 57.6423 23.9869 59.6323 24.255 61.6218C24.3662 62.4444 24.8796 63.2739 25.8111 63.9809C36.5546 72.101 47.0758 80.462 57.3624 89.0535C57.5718 89.2291 57.7982 89.3903 58.0393 89.5353C60.2069 90.8402 63.526 90.8968 65.8024 89.4816C85.487 77.2763 101.056 60.8922 109.587 41.5783V41.5771Z",
    fill: "url(#paint1_linear_3864_6847)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6845 58.5411C78.671 58.533 78.658 58.5255 78.6445 58.518C70.2415 53.6605 61.838 48.8024 53.4361 43.9455C52.2659 43.2858 50.6352 43.6041 49.7819 44.6473C48.9421 45.6721 49.1814 47.0174 50.3229 47.691C50.3288 47.6945 50.3341 47.6979 50.3399 47.7008C50.3535 47.7106 75.9852 62.338 75.9864 62.3386C77.1779 62.9989 78.7392 62.6864 79.4625 61.6304C80.1776 60.5866 79.8201 59.2118 78.6845 58.5411Z",
    fill: "url(#paint2_linear_3864_6847)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1708 50.117C87.1573 50.1089 87.1444 50.1014 87.1308 50.0939C78.7279 45.2364 70.3243 40.3783 61.9225 35.5214C60.7522 34.8617 59.1215 35.18 58.2682 36.2232C57.4284 37.248 57.6678 38.5934 58.8092 39.2669C58.8151 39.2704 58.8204 39.2738 58.8263 39.2767C58.8398 39.2865 84.4716 53.914 84.4728 53.9145C85.6642 54.5748 87.2255 54.2623 87.9489 53.2063C88.664 52.1625 88.3064 50.7877 87.1708 50.117Z",
    fill: "url(#paint3_linear_3864_6847)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.207 40.5755C93.1934 40.5674 93.1805 40.5599 93.167 40.5524C84.764 35.6949 76.3604 30.8368 67.9586 25.9799C66.7883 25.3202 65.1576 25.6385 64.3043 26.6817C63.4645 27.7065 63.7039 29.0519 64.8453 29.7254C64.8512 29.7289 64.8565 29.7323 64.8624 29.7352C64.8759 29.745 90.5077 44.3725 90.5089 44.373C91.7003 45.0333 93.2617 44.7208 93.985 43.6648C94.7001 42.621 94.3425 41.2462 93.207 40.5755Z",
    fill: "url(#paint4_linear_3864_6847)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3455 60.1581C49.1758 59.4372 48.9324 58.1276 49.828 57.1491C50.7366 56.1572 52.4349 55.9025 53.6358 56.5899C58.2463 59.2471 62.8544 61.9049 67.4614 64.5639C68.6652 65.2478 68.9763 66.6255 68.1512 67.6266C67.3267 68.6277 65.6578 68.8726 64.4352 68.184C64.4358 68.1829 50.3614 60.1673 50.3455 60.1575V60.1581Z",
    fill: "url(#paint5_linear_3864_6847)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3864_6847",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 92
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90941 85.3315L41.4426 91.907C44.7276 92.4823 47.8644 90.3294 48.4442 87.1014L62.4986 8.83305C63.129 5.32148 60.4833 2.06234 56.8578 1.88385L18.6407 0.00588691C16.2531 -0.111377 14.1501 1.53552 13.7349 3.84788L0.0728135 79.9385C-0.38118 82.4681 1.33482 84.8809 3.90941 85.3321V85.3315Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3864_6847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06865 85.1811L43.5558 92.2834C45.6652 92.649 47.6776 91.2656 48.0498 89.1929L62.9081 6.461C63.315 4.19427 61.599 2.09334 59.2585 1.99225L17.854 -0.00239891C15.9092 -0.0861591 14.2021 1.2592 13.8639 3.14236L-0.0775482 80.7672C-0.449799 82.8393 0.958638 84.816 3.06865 85.1817V85.1811Z",
    fill: "url(#paint6_linear_3864_6847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06865 85.1811L43.1312 92.21C45.4752 92.6161 47.7105 91.079 48.1245 88.7764L62.8222 6.93583C63.2745 4.41725 61.3679 2.08294 58.7669 1.97088L17.854 -0.00239891C15.9092 -0.0861591 14.2021 1.2592 13.8639 3.14236L-0.0775482 80.7672C-0.449799 82.8393 0.958638 84.816 3.06865 85.1817V85.1811Z",
    fill: "url(#paint7_linear_3864_6847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06865 85.1811L43.1312 92.21C45.4752 92.6161 47.7105 91.079 48.1245 88.7764L62.8222 6.93583C63.2745 4.41725 61.3679 2.08294 58.7669 1.97088L17.854 -0.00239891C15.9092 -0.0861591 14.2021 1.2592 13.8639 3.14236L-0.0775482 80.7672C-0.449799 82.8393 0.958638 84.816 3.06865 85.1817V85.1811Z",
    fill: "url(#paint8_linear_3864_6847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95985 81.0848L39.8073 86.502C41.5886 86.7955 43.2734 85.613 43.568 83.8627L55.9523 10.2029C56.2669 8.3324 54.869 6.60348 52.9425 6.48101L20.909 4.44708C19.1624 4.33617 17.6081 5.52846 17.2947 7.21983L4.28882 77.3485C3.96244 79.1074 5.16446 80.7884 6.95927 81.0848H6.95985Z",
    fill: "url(#paint9_linear_3864_6847)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1431 20.8457C32.9582 20.658 31.6997 20.6707 30.3995 20.9168C23.726 22.1801 18.9267 28.5915 20.7598 35.2242C24.0247 47.039 42.5567 42.8088 42.7661 31.4526C42.866 26.0342 39.1688 21.6412 34.1431 20.8457Z",
    fill: "url(#paint10_radial_3864_6847)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1469 35.308C38.3065 40.6699 31.7065 43.293 26.4056 41.1666C21.1047 39.0403 19.11 32.9697 21.9504 27.6079C24.7908 22.2461 31.3907 19.6229 36.6916 21.7493C41.9925 23.8756 43.9873 29.9462 41.1469 35.308Z",
    fill: "url(#paint11_radial_3864_6847)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M24.3119 28.0455C24.1013 28.358 23.8432 28.618 23.5303 28.525C23.2945 28.4551 23.1839 28.1859 23.1675 27.945C23.1275 27.3627 23.445 26.8151 23.8085 26.3536C24.5618 25.3964 25.5692 24.5374 26.6983 24.0401C26.877 23.9615 27.0705 23.8968 27.2658 23.9136C27.461 23.9309 27.658 24.0487 27.7139 24.2336C27.8803 24.7852 26.6259 25.4732 26.2649 25.7569C25.6915 26.2068 25.181 26.7348 24.7512 27.3194C24.6365 27.4754 24.4918 27.7792 24.3125 28.0455H24.3119Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4517 27.9601C36.1195 27.9105 35.7725 27.9827 35.4802 28.1906C33.4667 29.6232 31.3984 31.061 29.2766 32.5051C28.5662 31.4353 27.8582 30.3626 27.1507 29.2853C26.9226 28.9381 26.5715 28.7267 26.1951 28.6701C25.8582 28.6198 25.5012 28.6932 25.1936 28.9046C24.5438 29.3529 24.355 30.2517 24.7808 30.9091C25.7341 32.3821 26.6903 33.8482 27.6477 35.3085C27.8529 35.6222 28.1775 35.8371 28.5521 35.9064C28.568 35.9093 28.5845 35.9122 28.6003 35.9145C28.9591 35.9682 29.3325 35.8839 29.6395 35.6782C32.2088 33.9643 34.6998 32.2585 37.1133 30.5607C37.7443 30.1177 37.8796 29.2293 37.4244 28.5742C37.1833 28.227 36.8269 28.0156 36.4517 27.9596V27.9601Z",
    fill: "url(#paint12_linear_3864_6847)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4036 13.1937C51.1672 14.345 50.0251 15.0901 48.8531 14.8579C47.6811 14.6257 46.9225 13.5039 47.1589 12.3526C47.3953 11.2013 48.5373 10.4562 49.7094 10.6884C50.8814 10.9206 51.64 12.0424 51.4036 13.1937Z",
    fill: "#BED8D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4009 13.8533C51.2863 13.0636 51.3523 11.7185 50.5484 10.8488C49.7445 9.97918 48.3751 9.91433 47.4898 10.704C46.6044 11.4936 46.5384 12.8388 47.3423 13.7084C48.1462 14.5781 49.5156 14.6429 50.4009 13.8533Z",
    fill: "url(#paint13_linear_3864_6847)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7156 81.703L27.7816 82.9397C28.9013 83.1113 29.951 82.3586 30.1257 81.2587C30.3003 80.1589 29.5341 79.1278 28.4144 78.9562L20.3484 77.7194C19.2287 77.5479 18.179 78.3006 18.0043 79.4004C17.8296 80.5003 18.5959 81.5314 19.7156 81.703Z",
    fill: "#BED8D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4968 81.2044L27.5629 82.4412C28.6826 82.6127 29.7323 81.8601 29.9069 80.7602C30.0816 79.6603 29.3153 78.6292 28.1956 78.4577L20.1296 77.2209C19.0099 77.0493 17.9602 77.802 17.7855 78.9019C17.6109 80.0017 18.3772 81.0329 19.4968 81.2044Z",
    fill: "url(#paint14_linear_3864_6847)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5724 62.909L35.8589 65.8522C36.9786 66.0237 38.0283 65.271 38.203 64.1712C38.3776 63.0713 37.6114 62.0402 36.4917 61.8687L17.2058 58.9255C16.0861 58.7539 15.0364 59.5066 14.8617 60.6065C14.6871 61.7063 15.4533 62.7374 16.573 62.909H16.5724Z",
    fill: "url(#paint15_linear_3864_6847)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4359 53.6834L37.7218 56.6266C38.8415 56.7981 39.8912 56.0455 40.0659 54.9456C40.2405 53.8457 39.4743 52.8146 38.3546 52.6431L19.0681 49.6999C17.9484 49.5283 16.8987 50.281 16.724 51.3809C16.5494 52.4807 17.3156 53.5119 18.4353 53.6834H18.4359Z",
    fill: "url(#paint16_linear_3864_6847)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3864_6847",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2326 1.89594) rotate(31.2936) scale(112.979 112.067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DFEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ECFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D5EAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#BED8D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3864_6847",
    x1: 97.5954,
    y1: 13.9897,
    x2: 39.3795,
    y2: 85.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E3ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BED8D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3864_6847",
    x1: 68.2399,
    y1: 46.9824,
    x2: 61.8889,
    y2: 58.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8D1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BAD3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AFC5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9BAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3864_6847",
    x1: 76.7272,
    y1: 38.5575,
    x2: 70.3756,
    y2: 49.7257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8D1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BAD3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AFC5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9BAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3864_6847",
    x1: 82.7621,
    y1: 29.0151,
    x2: 76.4111,
    y2: 40.1835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8D1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BAD3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AFC5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9BAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3864_6847",
    x1: 62.3534,
    y1: 57.0335,
    x2: 56.3734,
    y2: 66.8836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8D1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BAD3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AFC5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9BAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3864_6847",
    x1: 55.4812,
    y1: 47.8241,
    x2: 7.38893,
    y2: 39.1912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D6FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#A477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A77AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#956BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#815ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#734EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6B47A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6945A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6A46AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#704AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7952C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#875DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9F6FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B078F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3864_6847",
    x1: 33.2988,
    y1: 0.661122,
    x2: 29.2568,
    y2: 94.7488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B68DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AC81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#A67AD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A579D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8158CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8259CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#865CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8E63DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3864_6847",
    x1: 23.4314,
    y1: 88.8529,
    x2: 38.5771,
    y2: -0.0901138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#432594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7257B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B099E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C9B3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3864_6847",
    x1: 23.0486,
    y1: 85.587,
    x2: 36.6625,
    y2: 5.33854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#DAE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3864_6847",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9742 30.3524) rotate(5.80603) scale(13.485 13.251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#70D179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#67BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#51AA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#48A153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#49A254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#50A958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5CB460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67BF67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3864_6847",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1739 30.9912) rotate(21.8539) scale(10.3296 10.8777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#67BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67BF67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3864_6847",
    x1: 28.9352,
    y1: 27.1381,
    x2: 33.3231,
    y2: 33.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5E37B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5E278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F5DF6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F5DA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5D44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D246"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3864_6847",
    x1: 47.0229,
    y1: 10.6723,
    x2: 50.943,
    y2: 14.0614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#BE80FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AA75F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9E6EF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9465EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8552EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6C33E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6125E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3864_6847",
    x1: 24.462,
    y1: 76.8818,
    x2: 23.1447,
    y2: 83.3804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CF8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#BE80FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AA75F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#9E6EF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9465EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#8552EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6C33E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6125E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3864_6847",
    x1: 27.5642,
    y1: 56.0325,
    x2: 25.7626,
    y2: 67.4911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8D1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BAD3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AFC5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9BAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3864_6847",
    x1: 29.4282,
    y1: 46.8073,
    x2: 27.6272,
    y2: 58.2659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B8D1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BAD3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AFC5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9BAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#717F82"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact-info.30aeead9c3f2a4e22751cdb6c18cf293.svg";
export { ForwardRef as ReactComponent };